<!-- 上传图片 -->
<template>
    <div v-if="componentsData.type == 16">
        <div class="bg-div" :style="bgStyle">
            <template v-if="componentsData.content.select_style == '1'">
                <div
                    v-if="componentsData.content.title"
                    :style="titleStyle"
                    class="title-box"
                >
                    {{ componentsData.content.title }}
                </div>
                <div :style="txtStyle" class="upload-boxs">
                    <div class="upload-box" :style="iconStyle">
                        <Icon type="md-camera" size="30" color="#fff" />
                    </div>
                    <div :style="textStyle">
                        最多上传{{ componentsData.content.maximum_upload }}张
                    </div>
                </div>
            </template>
            <template v-else-if="componentsData.content.select_style == '2'">
                <div
                    v-if="componentsData.content.title"
                    :style="titleStyle"
                    class="title-box"
                >
                    {{ componentsData.content.title }}
                </div>
                <div class="flex-sb">
                    <div class="upload-box2" :style="txtStyle">
                        <div class="upload-box3">
                            <div class="icon-box" :style="iconStyle">
                                <Icon type="md-camera" size="30" color="#fff" />
                            </div>
                        </div>
                    </div>
                    <div class="upload-box2" :style="txtStyle">
                        <div class="upload-box4">
                            <div class="icon-box" :style="iconStyle">
                                <Icon type="md-camera" size="30" color="#fff" />
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="componentsData.content.select_style == '3'">
                <div
                    v-if="componentsData.content.title"
                    :style="titleStyle"
                    class="title-box"
                >
                    {{ componentsData.content.title }}
                </div>
                <div class="flex-sb">
                    <div class="upload-box2" :style="txtStyle">
                        <div class="upload-box5">
                            <div class="icon-box" :style="iconStyle">
                                <Icon type="md-camera" size="30" color="#fff" />
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    computed: {
        iconStyle() {
            const content = this.componentsData.content;
            return {
                backgroundColor: content.icon_background_color,
            };
        },
        textStyle() {
            const content = this.componentsData.content;
            return {
                color: content.prompt_text_color,
            };
        },
        txtStyle() {
            const content = this.componentsData.content;
            return {
                backgroundColor: content.fill_color,
                border: `1px solid ${content.border_color}`,
            };
        },
        titleStyle() {
            const content = this.componentsData.content;
            return {
                color: content.title_color,
            };
        },
        bgStyle() {
            const content = this.componentsData.content;
            const style = {};
            if (content.bg_color) {
                style.backgroundColor = content.bg_color;
            }
            const bgImg = content.bg_img || {};
            if (bgImg.picview && content.bg_value) {
                style.backgroundImage = `url(${bgImg.picview})`;
            }
            style.padding = `${content.inner_spacing.top}px ${content.inner_spacing.left}px`;
            style.margin = `${content.outer_spacing.top}px ${content.outer_spacing.left}px`;
            style.borderRadius = `${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.top}px ${content.rounded_corner_setting.bottom}px ${content.rounded_corner_setting.bottom}px`;
            return style;
        },
    },
};
</script>

<style scoped>
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.upload-boxs {
    padding: 6px;
    border-radius: 4px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.upload-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border-radius: 4px;
}
.title-box {
    margin-bottom: 8px;
    font-size: 18px;
}
.icon-box {
    padding: 7px;
    border-radius: 50%;
}
.upload-box2 {
    width: 160px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.upload-box3 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 100px;
    border-radius: 4px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url(../../assets/controlPanel/idDocument/reverse-side-id.png);
}
.upload-box4 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 100px;
    border-radius: 4px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url(../../assets/controlPanel/idDocument/positive-id.png);
}
.upload-box5 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 120px;
    border-radius: 4px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url(../../assets/controlPanel/idDocument/business-license.png);
}
</style>